import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'theme';

const TimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  min-height: 300px;
`

const TimerText = styled.div`
  font-size: 32px;
  color: ${COLORS.GREY_T_100};
  font-weight: bold;
  text-align: center;
`

const CircleContainer = styled.div`
  width: 150px;
  height: 150px;
  border: 3px solid ${COLORS.GREY_T_100};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`

const CountdownNumber = styled.div`
  font-size: 72px;
  color: ${COLORS.GREY_T_100};
  font-weight: bold;
`

const StartMessage = styled.div`
  font-size: 48px;
  color: ${COLORS.GREY_T_100};
  font-weight: bold;
  text-align: center;
`

const Timer = ({ timerPhase, countdown }) => {
  return (
    <TimerContainer>
      {timerPhase === 'initial' && (
        <TimerText>Timer starts now...</TimerText>
      )}
      {timerPhase === 'countdown' && (
        <CircleContainer>
          <CountdownNumber>{countdown}</CountdownNumber>
        </CircleContainer>
      )}
      {timerPhase === 'start' && (
        <StartMessage>Start!</StartMessage>
      )}
    </TimerContainer>
  );
};

export default Timer;
